/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { trackStatisticsItemModelSchema } from "./trackStatisticsItemModelSchema.ts";
import { z } from "zod";

export const trackStatisticsItemModelPagedResultSchema = z.object({
    "totalItems": z.number().int(),
"itemsQuantity": z.number().int(),
"itemsOffset": z.number().int(),
"items": z.array(z.lazy(() => trackStatisticsItemModelSchema))
    })